export interface ChipState {
  showNone: boolean;
  showFriendBadge: boolean;
  showFollowChip: boolean;
  showAddFriend: boolean;
  showPending: boolean;
}

export function resolveChipState(
  isCurrentUser: boolean,
  isFriend: boolean,
  isPendingSent: boolean
): ChipState {
  if (isCurrentUser) {
    return { showNone: true, showFriendBadge: false, showFollowChip: false, showAddFriend: false, showPending: false };
  }
  if (isFriend) {
    return { showNone: false, showFriendBadge: true, showFollowChip: false, showAddFriend: false, showPending: false };
  }
  return {
    showNone: false,
    showFriendBadge: false,
    showFollowChip: true,
    showAddFriend: !isPendingSent,
    showPending: isPendingSent,
  };
}
